import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ImageProcess2 = () => {
  const data = useStaticQuery(graphql`
    {
      process2: file(relativePath: { eq: "blog/process-2.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 500
            placeholder: DOMINANT_COLOR
            layout: CONSTRAINED
          )
        }
      }
    }
  `)

  return <GatsbyImage image={getImage(data.process2)} />
}

export default ImageProcess2
